import { useEffect } from "react";
import { api } from "@/lib/api";

// Logs a record view to the person's Recent list (Quick Search). Renders nothing.
export default function RecentTracker({ kind, refId, label, sub = "", path }) {
  useEffect(() => {
    if (refId && label) api.addRecent({ kind, ref_id: refId, label, sub, path }).catch(() => {});
  }, [kind, refId, label, sub, path]);
  return null;
}
